import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Unstable_Grid2 as Grid } from '@mui/material';

import { Layouts } from 'components';

import { History } from './components';

const NetworkIndex: FC = () => {
  const { t } = useTranslation();

  function renderMain() {
    return (
      <Grid container direction="column" spacing={5} wrap="nowrap">
        <Grid>
          <Box marginBottom={2}>
            <Typography variant="h5" color="textSecondary">
              {t('network:engaging')}
            </Typography>
          </Box>
          <History />
        </Grid>
      </Grid>
    );
  }

  return <Layouts.App1Column main={renderMain()} />;
};

export default NetworkIndex;
